// Permission registry + per-member overrides (Batch 39).
import { api } from "@/lib/api";

let _registryCache = null;
let _registryPromise = null;

export async function loadRegistry() {
  if (_registryCache) return _registryCache;
  if (_registryPromise) return _registryPromise;
  _registryPromise = api.get("/permissions/registry").then(({ data }) => {
    _registryCache = data;
    _registryPromise = null;
    return data;
  });
  return _registryPromise;
}

export async function getMyPermissions(familyId) {
  if (!familyId) return null;
  const { data } = await api.get(`/families/${familyId}/me/permissions`);
  return data;
}

export async function getMemberPermissions(familyId, memberId) {
  const { data } = await api.get(
    `/families/${familyId}/members/${memberId}/permissions`,
  );
  return data;
}

export async function setMemberPermissions(familyId, memberId, overrides) {
  const { data } = await api.put(
    `/families/${familyId}/members/${memberId}/permissions`,
    { overrides: overrides || {} },
  );
  return data;
}
